import React, { useMemo, useContext } from 'react'
import { useTranslation } from 'react-i18next'

import Tag from '../Tag'
import { navigate } from 'gatsby'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons'
import styles from './styles.module.css'
import { checkHasAuthorizationToResource } from '../../helpers/authorization'
import { SideMenuContext } from '../../contexts/sideMenuContext'

function isOnMobileExperienceCloseMenu(isMenuOpen, maxMobileQuery, toggleMenu) {
  if (window.innerWidth <= maxMobileQuery && isMenuOpen) {
    toggleMenu()
  }
}

const SideMenuItem = ({ children, category, path, items = [], resources = [] }) => {
  const { t } = useTranslation()
  const { activePathname, submenu: activeSubmenu, setSubmenu, isMenuOpen, maxMobileQuery, toggleMenu } = useContext(SideMenuContext)
  const hasSubmenu = items.length > 0
  const isSubmenuOpen = activeSubmenu === category
  const isParentActive =
    hasSubmenu && !isSubmenuOpen && activePathname ? items.map(i => i.slug).includes(activePathname) : activePathname === path

  const newSlugs = useMemo(() => ['get-subscription-summary'], [])

  const onClickItem = () => {
    if (!hasSubmenu) {
      isOnMobileExperienceCloseMenu(isMenuOpen, maxMobileQuery, toggleMenu)
      navigate(path)
    }

    if (category !== activeSubmenu) {
      setSubmenu(category)
    } else {
      setSubmenu(null)
    }
  }

  const onClickSubitem = slug => {
    isOnMobileExperienceCloseMenu(isMenuOpen, maxMobileQuery, toggleMenu)
    navigate(slug)

    return void 0
  }

  return (
    <li role="none" data-testid="">
      <button
        className={`${styles.menuItem} ${isParentActive ? styles.menuItemActive : ''}`}
        onClick={onClickItem}
        role="menuitem"
        aria-expanded={isSubmenuOpen}
      >
        <span>{children}</span>
        {hasSubmenu && (
          <FontAwesomeIcon
            icon={faChevronDown}
            className={`${styles.menuItemChevron} ${isSubmenuOpen ? styles.menuItemChevronOpen : ''}`}
          />
        )}
      </button>
      {hasSubmenu && (
        <ul className={styles.subMenu} style={{ maxHeight: isSubmenuOpen ? '48.5rem' : 0 }}>
          {items.map(({ slug, title }, navItemIndex) => {
            const hasAuthorizationToResource = checkHasAuthorizationToResource(resources, slug)

            return (
              hasAuthorizationToResource && (
                <li key={navItemIndex} role="none">
                  <button
                    onClick={() => onClickSubitem(slug)}
                    role="menuitem"
                    tabIndex={isSubmenuOpen ? void 0 : -1}
                    className={`${styles.menuItem} ${activePathname === slug ? styles.menuOpenMenuItemActive : ''}`}
                  >
                    <div className={styles.subMenuDot}>
                      <i />
                    </div>
                    <span>{title}</span>
                    {newSlugs.some(item => slug.includes(item)) && <Tag class="hot-tag--blue hot-tag--sm">{t('general.new')}</Tag>}
                  </button>
                </li>
              )
            )
          })}
        </ul>
      )}
    </li>
  )
}

export default SideMenuItem
